module.exports = __webpack_public_path__ + "static/img/1037_big.d106813.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1037_big.png
// module id = i8I5
// module chunks = 1